import AssistantImg from "../../assets/ai-tutor/assistant.svg";
import CompleteProgressIcon from "../../assets/progress-view/completedNew.svg";
import CompletedConnectingLine from "../../assets/progress-view/lineCompletedNew.svg";
import ConnectingLine from "../../assets/progress-view/lineNew.svg";
import DefaultProgressIcon from "../../assets/progress-view/defaultNew.svg";
import FirstProgressIcon from "../../assets/progress-view/oneNew.svg";
import FirstTrophyIcon from "../../assets/progress-view/trophyOneNew.svg";
import GreenCompleteProgressIcon from "../../assets/progress-view/greenCompletedNew.svg";
import LeftIcon from "../../assets/progress-view/leftIcon.svg";
import LinkIcon from "../../assets/svgs/link.svg";
import NewQuestionImage from "../../assets/svgs/newQuestion.svg";
import RightIcon from "../../assets/progress-view/rightIcon.svg";
import SecondProgressIcon from "../../assets/progress-view/twoNew.svg";
import SecondTrophyIcon from "../../assets/progress-view/trophyTwoNew.svg";
import TrophyCompletedIcon from "../../assets/progress-view/trophyCompletedNew.svg";
import TrophyIcon from "../../assets/progress-view/trophyNew.svg";
import EmptyProgressIcon from "../../assets/progress-view/emptyProgressIcon.svg";
import assistantStyle from "../../components/molecules/ai-tutor/Assistant/assistant.module.css";
import discussSymbol from "../../assets/ai-tutor/discussSymbol.svg";
import discussedSymbol from "../../assets/ai-tutor/discussedSymbol.svg";
import play from "../../assets/factualPlay.svg";
import fibStyle from "../../styles/QuestionLayout/Fib.module.css";
import mcqStyle from "../../styles/QuestionLayout/Mcq.module.css";
import questionLayoutStyle from "../../styles/QuestionLayout/QuestionLayout.module.css";
import scqStyle from "../../components/molecules/optionLayouts/scqTemp.module.css";
import styles from "./tutorReview.module.css";
import CheckmarkCircle from "../../assets/svgs/checkmarkCircle.svg";
import closeCircle from "../../assets/svgs/closeCircle.svg";
import factualStyle from "../../components/molecules/factual/factual.module.css";
import ArrowImg from "../../assets/ai-tutor/arrow.svg";
import TrophyStartedIcon from "../../assets/progress-view/trophyStartedIcon.svg";
export const commonProps = {
  mcqStyle: mcqStyle,
  fibStyle: fibStyle,
  scqStyle: scqStyle,
  questionLayoutStyle: questionLayoutStyle,
  reviewStyle: styles,
  assistantStyle: assistantStyle,
  factualStyle: factualStyle,
  icons: {
    AssistantImg: AssistantImg,
    discussIcon: LinkIcon,
    DiscussSymbol: discussSymbol,
    DiscussedSymbol: discussedSymbol,
    play: play,
    Arrow: ArrowImg,
    progressViewIcons: {
      DefaultProgressIcon: DefaultProgressIcon,
      FirstProgressIcon: FirstProgressIcon,
      SecondProgressIcon: SecondProgressIcon,
      CompleteProgressIcon: CompleteProgressIcon,
      GreenCompleteProgressIcon: GreenCompleteProgressIcon,
      ConnectingLine: ConnectingLine,
      CompletedConnectingLine: CompletedConnectingLine,
      TrophyIcon: TrophyIcon,
      FirstTrophyIcon: FirstTrophyIcon,
      SecondTrophyIcon: SecondTrophyIcon,
      TrophyCompletedIcon: TrophyCompletedIcon,
      LeftIcon: LeftIcon,
      RightIcon: RightIcon,
      EmptyProgressIcon: EmptyProgressIcon,
      TrophyStartedIcon: TrophyStartedIcon
    },
    CheckmarkCircle: CheckmarkCircle,
    closeCircle: closeCircle
  },
  loaderText:
  "Take a deep breath! Brace up for comprehension question. Read the passage and answer the questions",
  finalText:
  "Once you select your answer and hit Next, you won't be able to change it - so take a moment to be sure before locking it in!"
};